<div class="settings-container noscrollbar" [ngClass]="rootClassName">
  <div class="settings-profile-settings" [ngClass]="isNavigationVisible?isWeb?'ms-2 pt-3':'ms-0 pt-1':isWeb?'ms-0 pt-3':'ms-0 pt-1'">
      <div class="settings-content">
      <div class="container-fluid px-0 pt-1 pt-md-0 mt-2 mt-md-0">
        @if (isNavigationVisible) {
          <ng-container [ngTemplateOutlet]="_closeButton"></ng-container>
        }
        <span class="settings-text01 headingboldlarge">
          <span>{{title}}</span>
        </span>
        <div class="frame4pxspacer"></div>
      </div>
      <div class="settings-content">
        @if(!isModal) {
        <div class="{{isWeb ? 'frame32pxspacer':'frame48pxspacer'}}"></div>
        <hr class="divider"/>
        <div class="frame8pxspacer"></div>
        } @else {
          <div class="frame16pxspacer"></div>
        }
        @for (slider of sliders; track $index) {
          <div class="settings-slider-group-container">
            <div class="settings-slider">
              <div class="slider-title-col">
                <span class="slider-name-text labelregularmedium">
                  <span>{{slider.name|titlecase}}</span>
                </span>
              </div>
              <div class="slider-slider-col">
                <div class="setting-slider-container" [ngClass]="rootClassName">
                  <ng-template [ngTemplateOutlet]="_sliderTemplate" [ngTemplateOutletContext]="{slider}"></ng-template>
                </div>
              </div>
              <div class="slider-label-col">
                <span class="slider-label-text labelregularmedium">
                  <span>{{slider.label|titlecase}}</span>
                </span>
              </div>
            </div>
            <div class="frame16pxspacer"></div>
          </div>
        }
        <div class="settings-row2">
          <div class="settings-listheading">
            <div class="frame16pxspacer"></div>
            <div class="settings-row3">
              <div class="settings-col09">
                <div class="settings-row4">
                  <span class="settings-text11 headingboldsmall">
                    <span>Extras</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="frame16pxspacer"></div>
          </div>
          <div class="frame8pxspacer"></div>
        </div>
        @for (slide of slides; track $index) {
          <div class="settings-slide">
            <div class="frame16pxspacer"></div>
            <div class="title-col">
              <span class="title-text labelregularmedium">
                <span>{{slide.title}}</span>
              </span>
            </div>
            <div class="group-col" (click)="onToggle(slide)">
              <div class="group" [ngClass]="{active: slide.active}">
                <div class="thumb" [ngClass]="{active: slide.active}"></div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #_sliderTemplate let-slider="slider">
  <mat-slider class="custom-slider" [ngStyle]="{'width':'100%'}" min="0" max="4" step="1" disableRipple="true" (change)="onSliderChange(slider)">
    <input class="custom-slider" matSliderThumb [(ngModel)]="slider.value">
  </mat-slider>
</ng-template>

<ng-template #_closeButton>
  <button
    type="button"
    class="btn-close position-absolute end-0"
    aria-label="Close"
    data-bs-dismiss="modal"
    (click)="onClose()"
  >
  </button>
</ng-template>
